import React from 'react';
import { ArraySlot } from 'react-plugin';
export function ControlActionSlot({ slotProps, plugOrder }) {
    return (React.createElement(ArraySlot, { name: "controlAction", slotProps: slotProps, plugOrder: plugOrder }));
}
